export function initSwiper() {
  if (typeof Swiper === "undefined") return;

  const swiperCommon = {
    loop: true,
    slidesPerView: "auto",
    spaceBetween: 30,
    centeredSlides: true,
    breakpoints: {
      430: { spaceBetween: 50 },
    },
  };

  new Swiper(".js-enjoy-swiper", {
    ...swiperCommon,
    navigation: {
      prevEl: ".js-enjoy-swiper .swiper-button-prev",
      nextEl: ".js-enjoy-swiper .swiper-button-next",
    },
  });
  new Swiper(".js-sightseeing-swiper", {
    ...swiperCommon,
    navigation: {
      prevEl: ".js-sightseeing-swiper .swiper-button-prev",
      nextEl: ".js-sightseeing-swiper .swiper-button-next",
    },
  });
}
